<template>
  <div
    class="cell column"
    data-test-claim-question-tree-category-item
    @click="$emit('register', item.title)"
    v-if="!isHidden"
  >
    <RouterLink
      :to="{ path: link + item.id }"
      :data-test="'option-' + item.id"
      :data-test-damagecode="getDamageCode(item)"
      active-class="active"
      :class="{ active: $route.path.split('/').includes(item.id) }"
>
      <h3 data-test-claim-question-tree-category-item-header v-html="item.title" />
      <p
        :class="{'increase-padding' : index < 1} "
        data-test-claim-question-tree-category-item-paragraph
        v-html="item.paragraph"
      />
      <span
        v-if="index === 0"
        :data-test-claim-question-tree-category-item-icon="item.policyTypeId"
        :class="['icon icon-large', 'policy-type-name-' + item.policyTypeId]"
      />
    </RouterLink>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router';

export default {
  name: 'Item',
  components: {
    RouterLink
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    link: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: null
    },
    isCarLeased: {
      type: Boolean,
      default: false
    },
    selectedPolicy: {
      type: Object,
      default: () => {
          return {
            isActive: null,
            isCarLeased: null
          };
      }
  }
  },
  computed: {
    isHidden() {
      return !(this.selectedPolicy.isActive && this.selectedPolicy.isCarLeased) &&
         (this.index > 0 && this.selectedPolicy.isCarLeased !== this.isCarLeased);
    }
  },
  methods: {
    getDamageCode(item) {
      if (
        item.action === undefined ||
        item.action.length === 0 ||
        item.action[0].type !== 'DamageCode'
      ) {
        return false;
      }

      let damageCodes = '';

      for (var i = 0; i < item.action.length; i++) {
        damageCodes += item.action[i].id;

        if (i + 1 < item.action.length) {
          damageCodes += '/';
        }
      }

      return damageCodes;
    }
  }
};
</script>
